<template>
  <div
    :class="[
      'record_icons flex flex-vertical-center',
      {'flex-between': isIconsSplit, 'flex-vertical-reverse': isVertical}
    ]"
  >
    <div>
      <b-tooltip
        v-if="isPotentialDuplicate"
        label="Potential Duplicate"
        :position="tooltipPosition"
        type="is-dark"
        class="record_icons--duplicate"
      >
        <icon-default
          icon="warning"
          size="is-small"
          class="mr-25"
        ></icon-default>
      </b-tooltip>

      <b-tooltip
        v-if="temperature && temperature.label !== 'None'"
        :label="temperature.label"
        :position="tooltipPosition"
        type="is-dark"
      >
        <icon-default
          icon="temperature"
          :size="isLargeIcons ? '' : 'is-small'"
          :class="['record_icons--temp mr-25', temperature.color]"
        ></icon-default>
      </b-tooltip>

      <b-tooltip
        v-if="dealProbability.score"
        label="Deal Probability"
        :position="tooltipPosition"
        type="is-dark"
        :class="['record_icons--probability', dealProbability.color]"
      >
        <icon-default
          class="pipeline-record-footer-icon"
          icon="deal-probability"
          size="is-small"
        ></icon-default>
      </b-tooltip>

      <b-tooltip
        v-if="record.campaign_id"
        :label="campaignLabel"
        :position="tooltipPosition"
        type="is-dark"
      >
        <icon-default
          :icon="campaignIcon"
          :size="isLargeIcons ? '' : 'is-small'"
          class="mr-25"
        ></icon-default>
      </b-tooltip>

      <b-tooltip
        v-if="incompleteRequiredTasks"
        :label="`${incompleteRequiredTasks.length} required ${incompleteRequiredTasks.length > 1 ? 'tasks' : 'task'}`"
        :position="tooltipPosition"
        type="is-dark"
      >
        <icon-default
          icon="task"
          :size="isLargeIcons ? '' : 'is-small'"
          color="is-danger"
          class="mr-25"
        ></icon-default>
      </b-tooltip>
    </div>

    <div :class="{'vertical_avatars': isVertical}">
      <app-avatar
        v-for="user in record.users"
        :key="user.id"
        :user-id="user.id"
        :size="isLargeIcons ? 28 : 18"
        :position="tooltipPosition"
        class="record_icons--avatar"
      ></app-avatar>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecordIcons",
  props: {
    record: {
      type: Object,
      required: true
    },
    includeTemp: {
      type: Boolean,
      default: false,
    },
    includeTasks: {
      type: Boolean,
      default: false,
    },
    tooltipPosition: {
      type: String,
      default: "is-right"
    },
    isIconsSplit: {
      type: Boolean,
      default: false
    },
    isVertical: {
      type: Boolean,
      default: false
    },
    isLargeIcons: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isPotentialDuplicate() {
      if (this.record.id === this.$store.getters["activeInboxLeadItem/recordId"]) return this.$store.getters["activeInboxLeadItem/isDuplicate"]

      const inboxCommItemRecord = this.$store.getters["activeInboxInboundCommItem/record"]
      if (inboxCommItemRecord && this.record.id === inboxCommItemRecord.id) return this.$store.getters["activeInboxInboundCommItem/isDuplicate"]

      return false
    },
    temperature() {
      if (this.includeTemp) {
        const label = this.$utils.getEnumLabelDeprecated("temperatureEnum", this.record.temperature);
        const color = label.toLowerCase();

        return {color, label};
      }

      return null;
    },
    dealProbability() {
      const score = this.record.deal_probability_score;

      let color = "red";
      if (score > 1 && score <= 3) color = "yellow";
      if (score >= 4) color = "green";

      return {color, score};
    },
    campaignIcon() {
      return this.$utils.getCampaignIcon(this.record.campaign_id);
    },
    campaignLabel() {
      let campaign = this.$store.getters.campaigns.find(campaign => campaign.id === this.record.campaign_id);
      return campaign.label;
    },
    incompleteRequiredTasks() {
      if (this.includeTasks) {
        let pipelineIncompleteTasks = this.$store.getters.pipelineIncompleteTasks;

        return pipelineIncompleteTasks.filter(task => {
          return task.record_id === this.record.id && task.is_required_to_change_status;
        });
      }

      return null;
    },
    incompleteRequiredTasksLabel() {
      const tasks = this.incompleteRequiredTasks;

      if (tasks) {
        return tasks.length + " required " + tasks.length > 1 ? "tasks" : "task";
      }
    }
  },
};
</script>


<style lang="scss" scoped>
@import "../../styles/variables/variables";

.record_icons {

  &--temp {

    &.cold {
      color: $blue;
    }

    &.warm {
      color: $yellow;
    }

    &.hot {
      color: $red;
    }
  }

  &--probability {

    &.red {
      color: $danger;
    }

    &.yellow {
      color: $warning;
    }

    &.green {
      color: $success;
    }
  }

  &--duplicate {
    color: $danger;
  }

  &--avatar {
    border: 2px solid $white;
    border-radius: 100%;

    &:not(:last-child) {
      margin-right: -8px;
    }
  }
}

.vertical_avatars {

  .record_icons--avatar {
    display: block;

    &:not(:first-child) {
      margin-top: -8px;
      margin-right: 0;
    }
  }
}
</style>
